import type { ReactNode, MouseEvent } from "react";
import styles from "./PhantomButton.module.css";

interface Props {
  children: ReactNode;
  title?: string;
  onClick?: (e: MouseEvent) => void;
}

export default function PhantomButton({
  title,
  onClick,
  children,
  ...props
}: Props) {
  return (
    <button
      type="button"
      className={styles.PhantomButton}
      onClick={onClick}
      title={title}
      {...props}
    >
      <span className={styles.PhantomButtonText}>{children}</span>
    </button>
  );
}
